import Isotope from 'isotope-layout';
import 'isotope-packery';

import { csrfToken } from './utils';

const cards = document.querySelector('.article-cards.jq-cards');
const token = csrfToken();

// TODO: refactor

if (cards) {
    const grid = new Isotope(cards, {
        // options
        itemSelector: '.article-card',
        layoutMode: 'masonry',
        percentPosition: true,
        masonry: {
            columnWidth: '.article-cards__sizer',
            gutter: '.article-cards__gutter',
        },
    });

    if ($('#showmore').length) {
        const perRow = perRowDefault();
        const preload = perRow - ($('#showmore').siblings().not($('#showmore')).length % perRow);
        if (preload) {
            loadPosts(grid, perRow * 6, preload);
        } else {
            showMore(grid, perRow * 6);
        }
    }
}

function loadPosts(grid, loadCount = null, preload = null) {
    if (preload !== null) {
        var amount = preload;
    } else if (loadCount) {
        var amount = loadCount;
        if (amount < 30) {
            amount = 30;
        }
    } else {
        var amount = perRowDefault() * 6;
        if (amount < 30) {
            amount = 30;
        }
    }

    $.ajax({
        url: window.location.pathname,
        type: 'POST',
        data: `amount=${amount}&last=${$('#showmore').data('last')}&_csrf=${token}`,
        dataType: 'html',
        success: function (html) {
            $('#showmore').remove();
            if (html) {
                const $showmore = $(html).filter('#showmore').first();
                const $newCards = $(html).filter('.article-card');

                if ($showmore.length) {
                    $(grid.element).parent().append($showmore);
                }

                grid.insert($newCards);
            }
            if ($('#showmore').length) {
                showMore(grid, loadCount);
            }
        },
    });
}

function showMore(grid, perPage) {
    let block = false;
    if ($('#showmore').length) {
        $(window).scroll(function () {
            if ($(window).scrollTop() + $(window).height() > $(document).height() - 250 && !block) {
                block = true;
                loadPosts(grid, perPage);
            }
        });
    }
}

function perRowDefault() {
    let perRow = 0;
    let fromLeft = 0;

    $('#showmore')
        .siblings()
        .not($('#showmore'))
        .each(function () {
            if ($(this).position().left > fromLeft) {
                perRow++;
                fromLeft = $(this).position().left;
            } else {
                return false;
            }
        });

    return perRow;
}



// WEBPACK FOOTER //
// ./scripts/article-cards.js